import type { SimpleGit } from 'simple-git';
import { revParseSafe } from './rev-parse-safe.js';

export async function firstResolvedRef(g: SimpleGit, candidates: readonly string[]): Promise<string | null> {
  const resolved = await Promise.all(
    candidates.map(async (ref) => ({ ref, sha: await revParseSafe(g, ref) })),
  );
  return resolved.find((entry) => entry.sha)?.ref ?? null;
}

export async function firstResolvedSha(g: SimpleGit, candidates: readonly string[]): Promise<string | null> {
  const resolved = await Promise.all(
    candidates.map(async (ref) => ({ ref, sha: await revParseSafe(g, ref) })),
  );
  return resolved.find((entry) => entry.sha)?.sha ?? null;
}
